export enum HEALTH_CHECK_TYPE {
    /** For a health check made on the first meeting with a patient */
    INITIAL = 0,
    /** For a health check made during a patient program or monitoring */
    CHECK_UP = 1,
    /** For a health check made at the end of a patient program or monitoring */
    FINAL = 2
}

export enum HEALTH_CHECK_ITEM_DATATYPE {
    /** Boolean, encoded as "true" or "false" */
    BOOLEAN = 0,
    /** Text (max. 500 characters) */
    TEXT = 1,
    /** Date, encoded as unix epoch */
    DATE = 2
}


export type HealthCheckFieldTypes = {
    "HEALTH_CHECK_TYPE": HEALTH_CHECK_TYPE,
    "HEALTH_CHECK_ITEM_DATATYPE": HEALTH_CHECK_ITEM_DATATYPE

}

// FieldTypeNames are used in SQL table definitions in order to define which marshallers should be used to marshal / unmarshal object from / to DB
export type HealthCheckFieldTypeName = keyof HealthCheckFieldTypes;